'use client';

import { Inbox, X } from 'lucide-react';

import { usePreferences } from '@/components/preferences-provider';

export function PageHeader({ title, description, action }: { title: string; description: string; action?: React.ReactNode }) {
  return <div className="page-heading"><div><h1>{title}</h1><p>{description}</p></div>{action}</div>;
}

export function LoadingRows() {
  const { t } = usePreferences();
  return <div className="card empty"><div><div style={{ width: 34, height: 34, margin: '0 auto 12px', border: '3px solid var(--line)', borderTopColor: 'var(--primary)', borderRadius: '50%', animation: 'spin .7s linear infinite' }} /><span>{t('loading')}</span><style>{'@keyframes spin{to{transform:rotate(360deg)}}'}</style></div></div>;
}

export function EmptyState({ message }: { message?: string }) {
  const { t } = usePreferences();
  return <div className="card empty"><div><Inbox size={40} style={{ marginBottom: 10 }} /><div>{message ?? t('noData')}</div></div></div>;
}

export function Modal({ title, children, onClose }: { title: string; children: React.ReactNode; onClose: () => void }) {
  return <div className="modal-backdrop" role="presentation" onMouseDown={(event) => { if (event.currentTarget === event.target) onClose(); }}><section className="modal" role="dialog" aria-modal="true" aria-label={title}><div className="modal-head"><h2>{title}</h2><button className="button icon" onClick={onClose} aria-label="Close"><X /></button></div>{children}</section></div>;
}

export function StatusBadge({ status }: { status: string }) {
  return <span className={`badge ${status.toLowerCase()}`}>{status.replaceAll('_', ' ')}</span>;
}
